<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ errors,failedRules }"
      :rules="validationRules ? validationRules.field : 'required'"
      :name="questionId"
      :vid="`${stepId}_${questionId}`"
    >
      <text-input
        v-model="questionData[questionFields.field]"
        :placeholder="placeholder"
        :text-transform="textTransform"
        :error-messages="getFieldErrors('field', failedRules, errors)"
        :max-length="maxLength"
        :data-test="questionFields.field"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';
import TextInput from '@/components/TextInput/TextInput';

export default {
  name: 'question-base-text',
  extends: QuestionBase,
  components: {
    QuestionBaseWrapper,
    TextInput,
  },
  data () {
    return { fields: ['field'] };
  },
  props: {
    placeholder: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    textTransform: {
      type: String,
      default: 'capitalize',
      validator: value => ['uppercase', 'lowercase', 'capitalize', 'none'].includes(value),
    },
  },
};
</script>
